import React, { useEffect } from "react";
import PageMetaData from "../../../CustomComponents/PageMetaData/PageMetaData";
import CustomerHeader from "../CustomerHeader/CustomerHeader";
import CustomerSideBar from "../CustomerSideBar/CustomerSideBar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../assets/toastUtils";
import { useState } from "react";
import Loader from "../../../CustomComponents/Loader/Loader";
import AddressAutocomplete from "../../../CustomComponents/CustomGooglePlaceAPi/AddressAutocomplete";
import InputField from "../../../CustomComponents/InputField/InputField";

function CustomerProfile() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialRole = queryParams.get("role") || "profile";
  const [activeTab, setActiveTab] = useState(initialRole);
  const [loader, setLoader] = useState(true);
  const [edit, setEdit] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  const handleEditBtn = () => {
    setEdit(!edit);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    address: "",
    gst_information: "",
    company_information: "",
  });

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const handleAddressData = (data) => {
    // console.log(data, "data");
    setAddressData(data);
  };
  // console.log(formData, "formData");

  const navigate = useNavigate();
  useEffect(() => {
    const userType = localStorage.getItem("userType");

    if (userType === "agent") {
      navigate("/agent-account");
    }
  }, [navigate]);
  const userToken = localStorage.getItem("token");

  const [customerDataa, setCustomerData] = useState(null);

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    if (userDetails) {
      setFormData(userDetails);
    }
  }, []);

  useEffect(() => {
    const role = queryParams.get("role") || "profile";
    setActiveTab(role);
  }, [location.search]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const profileFilter = (tab) => {
    setActiveTab(tab);
  };

  // const fetchCustomerDetails = () => {
  //   fetch(`${process.env.REACT_APP_APP_URL}/api/v1/customers/user-profile`, {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${userToken}`,
  //     },
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.success) {
  //         setCustomerData(data.data.customer);
  //         setLoader(false);
  //         setFormData({
  //           name: data.data.customer.Name || "",
  //           phone: data.data.customer.PhoneNumber || "0",
  //           email: data.data.customer.Email || "",
  //         });
  //         localStorage.setItem(
  //           "userDetails",
  //           JSON.stringify(data.data.customer)
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(
  //         "There has been a problem with your fetch operation:",
  //         error
  //       );
  //     });
  // };

  const fetchCustomerDetails = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    const cookie = process.env.REACT_APP_COOKIE || "";
    myHeaders.append("Cookie", cookie);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/user-profile`,
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        setCustomerData(result.data);
        setLoader(false);
        setFormData({
          name: result.data.name || "",
          phone: result.data.phone || "",
          email: result.data.email || "",
          city: result.data.city || "",
          state: result.data.state || "",
          country: result.data.country || "",
          zipcode: result.data.zipcode || "",
          address: result.data.address || "",
          gst_information: result.data.additional_details?.gst || "",
          company_information: result.data.additional_details?.company || "",
        });
        setAddressData({
          country: result?.data?.country || "",
          state: result?.data?.state || "",
          city: result?.data?.city || "",
          address: result?.data?.address || "",
          latitude: result?.data?.latitude || "",
          longitude: result?.data?.longitude || "",
          placeId: result?.data?.placeId || "",
        });
        localStorage.setItem("userDetails", JSON.stringify(result.data));
      } else {
        showErrorToast(
          result.message || "User Profile not fetched successfully.."
        );
      }
    } catch (error) {
      console.error("Error fetching customer details:", error);
    }
  };

  useEffect(() => {
    fetchCustomerDetails();
  }, []);

  const handleSubmit2 = (e) => {
    e.preventDefault();
    const cust_id = customerDataa?.AgentId;
    const valid = validate();
    setTimeout(() => {
      setFormErrors({});
    }, 1500);
    if (!valid) {
      showErrorToast("Please fill the above details.");
      return;
    }

    const raw = JSON.stringify({ ...formData, ...addressData });

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_APP_URL}/api/customer/update/${cust_id}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      // .then((data) => {
      //   console.log(data, "datatta")
      //   setFormData({
      //     name: data.data.name || "",
      //     phone: data.data.phone || "0",
      //     email: data.data.email || "",
      //   });
      //   localStorage.setItem("userDetails", JSON.stringify(data.data));
      //   showSuccessToast("Profile Updated Successfully")
      //   navigate("/");
      // })
      // .catch((error) => {
      //   showErrorToast("Unable to update data");
      //   console.error(
      //     "There has been a problem with your fetch operation:",
      //     error
      //   );
      // });
      .then((data) => {
        setFormData({
          name: data.data.name || "",
          phone: data.data.phone || "",
          email: data.data.email || "",
        });
        localStorage.setItem("userDetails", JSON.stringify(data.data));
        showSuccessToast("Profile Updated Successfully");
        // navigate("/");
        window.location.href = "/";
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );
  };

  const validate = () => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = "required";
    }
    if (!formData.email.trim()) {
      errors.email = "required";
    }
    if (!formData.phone.trim()) {
      errors.phone = "required";
    }
    // if (!formData.address.trim()) {
    //   errors.address = "required";
    // }
    // if (!formData.city.trim()) {
    //   errors.city = "required";
    // }
    // if (!formData.state.trim()) {
    //   errors.state = "required";
    // }
    // if (!formData.country.trim()) {
    //   errors.country = "required";
    // }
    // if (!formData.zipcode.trim()) {
    //   errors.zipcode = "required";
    // }
    if (!formData.gst_information.trim()) {
      errors.gst_information = "required";
    }
    if (!formData.company_information.trim()) {
      errors.company_information = "required";
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      showErrorToast("Please fill the above details.");
      return;
    }

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);

    const cookie = process.env.REACT_APP_COOKIE || "";
    if (cookie) {
      myHeaders.append("Cookie", cookie);
    }
    const raw = JSON.stringify({ ...formData, ...addressData });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/customer/update`,
        requestOptions
      );

      if (response.ok) {
        const result = await response.json();
        showSuccessToast(result.message || "Profile Updated Successfully");
        setEdit(true);
        setEditData(false);
        localStorage.setItem("userDetails", JSON.stringify(result.data));
        fetchCustomerDetails();
        window.location.reload();

        // setFormData({
        //   name: result.data.name || "",
        //   phone: result.data.phone || "",
        //   email: result.data.email || "",
        //   city: result.data.city || "",
        //   state: result.data.state || "",
        //   country: result.data.country || "",
        //   zipcode: result.data.zipcode || "",
        //   address: result.data.address || "",
        //   gst_information: result.data.gst_information || "",
        //   company_information: result.data.company_information || "",
        // });
        // navigate("/customer-profile");
        // window.location.href = "/";
      } else {
        const errorText = await response.text();
        console.error("Failed to update customer details:", errorText);
      }
    } catch (error) {
      console.error("Error updating customer details:", error);
    }
  };

  const [currentStep, setCurrentStep] = useState(1);
  const [editData, setEditData] = useState({
    general_details: false,
    address_details: false,
    business_details: false,
    contact_details: false,
  });

  return (
    <div className="customer_profile_page">
      <PageMetaData
        title="Mountain Mysteries"
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <div className="sidebar_main_div new_sidebar_main_div">
        <CustomerSideBar />
        <div className="agent-info-container">
          <CustomerHeader />
          {loader ? (
            <Loader size="4em" color="#009A50" />
          ) : (
            <section className="w-full">
              <div className="setting-bg-white-div mt-10 flex justify_content_between align_items_center flex_wrap">
                <div>
                  {" "}
                  <h4 className=" ">Settings</h4>
                  <span
                    style={{
                      color: "#888888",
                      display: "block",
                    }}
                  >
                    Set your account settings down below
                  </span>
                </div>{" "}
                <div className="flex align_items_center flex_gap_5 align_top">
                  <button
                    className="vendor_common_property"
                    onClick={(e) => {
                      handleSubmit(e);
                      // setTimeout(() => handleSubmit(e), 300);
                    }}
                    type="button"
                  >
                    Save Changes
                  </button>
                </div>
                {/* ))} */}
              </div>
              <div className="flex-div_profile_Sec">
                <div className="w-half-div">
                  <div className=" profile-bg-white-div mt-10">
                    <div className="flex align_items_center flex_gap_10">
                      {" "}
                      <div
                        className="profile_name_div"
                        style={{
                          height: "80px",
                          width: "80px",
                          fontSize: "30px",
                        }}
                      >
                        {formData?.name?.charAt(0)}
                      </div>
                      <div>
                        {" "}
                        <h4 className=" text-capitalize"> {formData.name}</h4>
                      </div>
                    </div>
                    <div className="profile_sec_link">
                      <Link to="tel:9816012966">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_7312_12223"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="18"
                            height="18"
                          >
                            <rect width="18" height="18" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_7312_12223)">
                            <path
                              d="M14.5802 15.375C13.1668 15.375 11.7469 15.0464 10.3204 14.3891C8.894 13.7319 7.58225 12.8048 6.38513 11.6077C5.19288 10.4106 4.26813 9.1 3.61088 7.67588C2.95363 6.25188 2.625 4.83319 2.625 3.41981C2.625 3.19481 2.7 3.00606 2.85 2.85356C3 2.70119 3.1875 2.625 3.4125 2.625H5.85862C6.048 2.625 6.21506 2.68681 6.35981 2.81044C6.50456 2.93394 6.59663 3.08656 6.636 3.26831L7.06594 5.475C7.09569 5.67975 7.08944 5.85569 7.04719 6.00281C7.00481 6.14994 6.92881 6.2735 6.81919 6.3735L5.08706 8.05969C5.36581 8.57019 5.68431 9.05313 6.04256 9.5085C6.40069 9.96375 6.78844 10.3986 7.20581 10.8129C7.61731 11.2246 8.05481 11.6068 8.51831 11.9597C8.98181 12.3126 9.48231 12.6409 10.0198 12.9448L11.7028 11.2472C11.8202 11.1251 11.9623 11.0394 12.1292 10.9903C12.2959 10.9413 12.4693 10.9293 12.6491 10.9543L14.7317 11.3784C14.9211 11.4284 15.0756 11.5251 15.1954 11.6683C15.3151 11.8116 15.375 11.9741 15.375 12.1558V14.5875C15.375 14.8125 15.2988 15 15.1464 15.15C14.9939 15.3 14.8052 15.375 14.5802 15.375Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                        {formData.phone}
                      </Link>
                      <Link to="mailto:sales@mountainmysteries.com">
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <mask
                            id="mask0_7312_12217"
                            style={{ maskType: "alpha" }}
                            maskUnits="userSpaceOnUse"
                            x="0"
                            y="0"
                            width="18"
                            height="18"
                          >
                            <rect width="18" height="18" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_7312_12217)">
                            <path
                              d="M3.23081 14.625C2.85194 14.625 2.53125 14.4938 2.26875 14.2313C2.00625 13.9688 1.875 13.6481 1.875 13.2692V4.73081C1.875 4.35194 2.00625 4.03125 2.26875 3.76875C2.53125 3.50625 2.85194 3.375 3.23081 3.375H14.7692C15.1481 3.375 15.4688 3.50625 15.7313 3.76875C15.9938 4.03125 16.125 4.35194 16.125 4.73081V13.2692C16.125 13.6481 15.9938 13.9688 15.7313 14.2313C15.4688 14.4938 15.1481 14.625 14.7692 14.625H3.23081ZM9 9.29419C9.0625 9.29419 9.1245 9.28481 9.186 9.26606C9.24762 9.24731 9.30725 9.22162 9.36487 9.189L14.7289 5.75475C14.8144 5.70187 14.8749 5.63338 14.9106 5.54925C14.9462 5.46513 14.9567 5.37644 14.9423 5.28319C14.9326 5.11006 14.848 4.98144 14.6884 4.89731C14.5289 4.81319 14.3679 4.82063 14.2054 4.91963L9 8.25L3.79463 4.91963C3.63213 4.82063 3.47231 4.81269 3.31519 4.89581C3.15794 4.97906 3.07212 5.10575 3.05775 5.27588C3.04325 5.37688 3.05381 5.47063 3.08944 5.55713C3.12506 5.64375 3.18563 5.70962 3.27113 5.75475L8.63513 9.189C8.69275 9.22162 8.75238 9.24731 8.814 9.26606C8.8755 9.28481 8.9375 9.29419 9 9.29419Z"
                              fill="white"
                            />
                          </g>
                        </svg>
                        {formData?.email}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="w-half-div">
                  <div className="setting-bg-white-div mt-10">
                    {" "}
                    {editData["general_details"] === true ? (
                      <div className="mt-10">
                        <div className="flex align_items_center justify_content_between">
                          <h4>1. General Details</h4>
                          <div className="flex align_items_center flex_gap_5">
                            <button
                              type="button"
                              onClick={() =>
                                setEditData((prev) => ({
                                  ...prev,
                                  general_details: false,
                                }))
                              }
                            >
                              <svg
                                width="13"
                                height="13"
                                viewBox="0 0 14 13"
                                style={{ margin: "5px" }}
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 12.5L13 0.5"
                                  stroke="#aaaaaa"
                                  strokeWidth="1.2"
                                />
                                <path
                                  d="M13 12.5L1 0.5"
                                  stroke="#aaaaaa"
                                  strokeWidth="1.2"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>{" "}
                        <div className="profile_content Profile mt-10">
                          <div>
                            {currentStep === 1 && (
                              <div>
                                <div>
                                  <div>
                                    <InputField
                                      label="Name"
                                      name="name"
                                      type="text"
                                      value={formData.name}
                                      onChange={handleInputChange}
                                      placeholder="Full Name"
                                      error={formErrors.name}
                                    />
                                  </div>
                                </div>

                                <div className="input-flex mt-10">
                                  <div>
                                    <InputField
                                      label="Email"
                                      name="email"
                                      type="email"
                                      value={formData.email}
                                      onChange={handleInputChange}
                                      placeholder="Email"
                                      error={formErrors.email}
                                    />
                                  </div>{" "}
                                  <div>
                                    <InputField
                                      label="Phone"
                                      name="phone"
                                      type="number"
                                      value={formData.phone}
                                      onChange={handleInputChange}
                                      placeholder="Phone"
                                      error={formErrors.phone}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="flex align_items_center justify_content_between">
                          <h4>1. General Details</h4>
                          <button
                            onClick={() =>
                              setEditData((prev) => ({
                                ...prev,
                                general_details: true,
                              }))
                            }
                            type="button"
                          >
                            <svg
                              width="22"
                              height="22"
                              viewBox="0 0 26 27"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_4568_4221"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="26"
                                height="27"
                              >
                                <rect
                                  y="0.5"
                                  width="26"
                                  height="26"
                                  fill="#009A50"
                                />
                              </mask>
                              <g mask="url(#mask0_4568_4221)">
                                <path
                                  d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                  fill="#009A50"
                                />
                              </g>
                            </svg>
                          </button>
                        </div>
                        <div className="profile_content Profile">
                          <div className="mt-10">
                            <div className="gap_items">
                              <div className=" w-half">
                                <p className="py-5">Name</p>
                                <p className="py-5">Email</p>
                                <p className="py-5">Phone</p>
                              </div>
                              <div className=" w-half overflow-hidden">
                                <p className="py-5 text-end">
                                  {formData?.name}
                                </p>
                                <p className="py-5 text-end">
                                  {formData.email || "-"}
                                </p>
                                <p className="py-5 text-end">
                                  {formData.phone || "-"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="setting_line"></div>
                    <div>
                      {" "}
                      {editData["address_details"] === true ? (
                        <div className="">
                          <div className="flex align_items_center justify_content_between">
                            <h4>2. Address</h4>
                            <div>
                              <button
                                // className="no_logout_btn"
                                type="button"
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    address_details: false,
                                  }))
                                }
                              >
                                <svg
                                  width="13"
                                  height="13"
                                  viewBox="0 0 14 13"
                                  style={{ margin: "5px" }}
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M1 12.5L13 0.5"
                                    stroke="#aaaaaa"
                                    strokeWidth="1.2"
                                  />
                                  <path
                                    d="M13 12.5L1 0.5"
                                    stroke="#aaaaaa"
                                    strokeWidth="1.2"
                                  />
                                </svg>
                              </button>
                            </div>
                          </div>
                          <div className="profile_content Profile mt-10">
                            <div>
                              <label
                                htmlFor="address"
                                className="address_label"
                              >
                                Address
                              </label>
                              <AddressAutocomplete
                                formdata={addressData}
                                style={
                                  formErrors.address && {
                                    backgroundColor: "#ff000040",
                                    border: "1px solid red",
                                  }
                                }
                                onAddressChange={handleAddressData}
                              />
                            </div>
                            <div className="mt-10">
                              <InputField
                                label="Zip Code"
                                name="zipcode"
                                type="text"
                                value={formData.zipcode}
                                onChange={handleInputChange}
                                placeholder="Zip Code"
                                error={formErrors.zipcode}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="">
                          <div className="flex align_items_center justify_content_between">
                            {" "}
                            <h4>2. Address</h4>
                            <button
                              // className="vendor_common_property"
                              onClick={() =>
                                setEditData((prev) => ({
                                  ...prev,
                                  address_details: true,
                                }))
                              }
                              type="button"
                            >
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 26 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_4568_4221"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="26"
                                  height="27"
                                >
                                  <rect
                                    y="0.5"
                                    width="26"
                                    height="26"
                                    fill="#009A50"
                                  />
                                </mask>
                                <g mask="url(#mask0_4568_4221)">
                                  <path
                                    d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                    fill="#009A50"
                                  />
                                </g>
                              </svg>
                            </button>
                          </div>
                          <div className="profile_content Profile mt-10">
                            <div className="gap_items">
                              <div className="w-half">
                                <p className="py-5">Country</p>
                                <p className="py-5">City</p>
                                <p className="py-5">State</p>
                                <p className="py-5">Address</p>
                                <p className="py-5">Zip Code</p>
                              </div>
                              <div className="w-half">
                                <p className="py-5">
                                  {addressData?.country || "-"}
                                </p>
                                <p className="py-5">
                                  {addressData?.city || "-"}
                                </p>
                                <p className="py-5">
                                  {addressData?.state || "-"}
                                </p>
                                <p className="py-5">
                                  {addressData?.address || "-"}
                                </p>
                                <p className="py-5">
                                  {formData?.zipcode ? formData?.zipcode : "-"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="setting_line"></div>
                    {editData["business_details"] === true ? (
                      <div className="">
                        <div className="flex align_items_center justify_content_between">
                          <h4>3. Business Information</h4>
                          <button
                            type="button"
                            onClick={() =>
                              setEditData((prev) => ({
                                ...prev,
                                business_details: false,
                              }))
                            }
                          >
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 14 13"
                              style={{ margin: "5px" }}
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 12.5L13 0.5"
                                stroke="#aaaaaa"
                                strokeWidth="1.2"
                              />
                              <path
                                d="M13 12.5L1 0.5"
                                stroke="#aaaaaa"
                                strokeWidth="1.2"
                              />
                            </svg>
                          </button>
                        </div>
                        <div className="profile_content Profile mt-10">
                          <div>
                            <div className="input-flex">
                              <div>
                                <InputField
                                  label="GST No."
                                  name="gst_information"
                                  type="text"
                                  value={formData.gst_information}
                                  onChange={handleInputChange}
                                  placeholder="GST No."
                                  error={formErrors.gst_information}
                                />
                              </div>
                              <div>
                                <label htmlFor="company_information"></label>
                                <InputField
                                  label="  Company Information"
                                  name="company_information"
                                  type="text"
                                  value={formData.company_information}
                                  onChange={handleInputChange}
                                  placeholder="  Company Information"
                                  error={formErrors.company_information}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="flex align_items_center justify_content_between">
                          <h4>3. Business Information</h4>
                          <div>
                            {" "}
                            <button
                              onClick={() =>
                                setEditData((prev) => ({
                                  ...prev,
                                  business_details: true,
                                }))
                              }
                              type="button"
                            >
                              <svg
                                width="22"
                                height="22"
                                viewBox="0 0 26 27"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_4568_4221"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="26"
                                  height="27"
                                >
                                  <rect
                                    y="0.5"
                                    width="26"
                                    height="26"
                                    fill="#009A50"
                                  />
                                </mask>
                                <g mask="url(#mask0_4568_4221)">
                                  <path
                                    d="M5.41667 21.0833H6.96042L17.55 10.4938L16.0063 8.95L5.41667 19.5396V21.0833ZM3.25 23.25V18.6458L17.55 4.37292C17.7667 4.17431 18.0059 4.02083 18.2677 3.9125C18.5295 3.80417 18.8049 3.75 19.0938 3.75C19.3826 3.75 19.6625 3.80417 19.9333 3.9125C20.2042 4.02083 20.4389 4.18333 20.6375 4.4L22.1271 5.91667C22.3438 6.11528 22.5017 6.35 22.601 6.62083C22.7003 6.89167 22.75 7.1625 22.75 7.43333C22.75 7.72222 22.7003 7.99757 22.601 8.25938C22.5017 8.52118 22.3438 8.76042 22.1271 8.97708L7.85417 23.25H3.25ZM16.7646 9.73542L16.0063 8.95L17.55 10.4938L16.7646 9.73542Z"
                                    fill="#009A50"
                                  />
                                </g>
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div className="profile_content Profile">
                          <div className="gap_items">
                            <div className="mt-10 w-half">
                              <p className="py-5">GST No.</p>
                              <p className="py-5">Company Information</p>
                            </div>
                            <div className="mt-10 w-half">
                              <p className="py-5">
                                {formData?.gst_information
                                  ? formData?.gst_information
                                  : "-"}
                              </p>
                              <p className="py-5">
                                {formData?.company_information
                                  ? formData?.company_information
                                  : "-"}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerProfile;
